import { render } from "./LegalIndication9.vue?vue&type=template&id=c0115b56"
import script from "./LegalIndication9.vue?vue&type=script&lang=js"
export * from "./LegalIndication9.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sung-hojang/git-projects/blackpay-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__